import { GridKeikka_NewKeikkaProvider } from "src/context/GridKeikka_NewKeikkaContext";
import PropTypes from "prop-types";
import GridKeikka_NewKeikkaLayout from "./GridKeikka_NewKeikkaModal/layout/GridKeikka_NewKeikkaLayout";

export default function GridKeikka_NewKeikkaCore({ defaults, onSelect }) {
  return (
    <GridKeikka_NewKeikkaProvider defaults={defaults}>
      <GridKeikka_NewKeikkaLayout onSelect={onSelect} />
    </GridKeikka_NewKeikkaProvider>
  );
}

GridKeikka_NewKeikkaCore.propTypes = {
  defaults: PropTypes.object,
  onSelect: PropTypes.func,
};
